var exports = {
  "kL": "GroupInvitesModal.module__container___TEVmMH",
  "CR": "GroupInvitesModal.module__modalRoot___TEVmMH" + " " + __webpack_require__(545076)["root"] + " " + __webpack_require__(545076)["large"],
  "dc": "GroupInvitesModal.module__spinnerContainer___TEVmMH",
  "Ye": "GroupInvitesModal.module__errorBox___TEVmMH",
  "kc": "GroupInvitesModal.module__errorText___TEVmMH",
  "Zb": "GroupInvitesModal.module__stateBox___TEVmMH",
  "r9": "GroupInvitesModal.module__stateText___TEVmMH",
  "Mp": "GroupInvitesModal.module__invitesWrapper___TEVmMH",
  "$h": "GroupInvitesModal.module__invitesList___TEVmMH",
  "XG": "GroupInvitesModal.module__scroller___TEVmMH",
  "eu": "GroupInvitesModal.module__inviteItems___TEVmMH",
};

module.exports = exports;
